export default {
	sec_10: {
		title: {
			one: 'JPYS 자체',
			two: '포인트 시스템',
		},
		desc: {
			one: '빠르고 안전한 자체 포인트 시스템',
			two: '고정 된 환율로 피곤함이 없습니다.',
		},
		btn: {
			one: '자산보내기',
			two: '앱 다운로드',
		},
	},
	sec_04: {
		title: '모든 시스템과 연동',
		desc: '오프라인 매장 및 온라인 스토어 모두 JPYS 하나만 있으면 다 됩니다.',
		cards: {
			one: {
				title: {
					one: '키오스크 및 포스기',
				},
				description: {
					one: '어디에서나 결제를 자유롭게',
				},
			},
			two: {
				title: {
					one: '편리한 충전',
				},
				description: {
					one: '원하는 암호자산 및 신용카드로',
					two: '즉시 충전이',
					three: '가능합니다.',
				},
			},
		},
	},
};
